import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setSubaccountQuery } from 'src/helpers/subaccounts';
import {
  selectLatestVersionNumberFromParams,
  selectIdAndVersionFromParams
} from 'src/selectors/abTesting';
import { LabelledValue, Subaccount } from 'src/components';
import { PageLink } from 'src/components/links';
import { ActionList, Panel, Popover } from 'src/components/matchbox';
import { ExpandMore } from '@sparkpost/matchbox-icons';
import StatusTag from './StatusTag';
import _ from 'lodash';
import { TranslatableText } from 'src/components/text';

// todo, this component is rendered as a panel action content and panel actions are buttons, this
//   doesn't work to have the Popover inside the Button
const VersionSelector = ({ current, latest, id, subaccountId }) => {
  const actions = _.times(latest, (i) => ({
    children: `View Version ${i + 1}`,
    to: `/ab-testing/${id}/${i + 1}${setSubaccountQuery(subaccountId)}`,
    as: PageLink,
    visible: i + 1 !== current
  })).reverse();

  return (
    <Popover
      id="popover-version-selector"
      left
      trigger={
        <Fragment>
          Version <span>{current}</span> <ExpandMore />
        </Fragment>
      }
    >
      <ActionList>
        {actions.map(({ children, ...action }, i) => {
          return (
            <ActionList.Action key={`action-item-${i}`} {...action}>
              <TranslatableText>{children}</TranslatableText>
            </ActionList.Action>
          );
        })}
      </ActionList>
    </Popover>
  );
};

export const StatusPanel = ({ test, version, id, subaccountId, latest, subaccountName }) => {
  let panelActions = null;

  if (latest > 1) {
    panelActions = [
      {
        content: (
          <VersionSelector current={version} id={id} latest={latest} subaccountId={subaccountId} />
        ),
        color: 'orange',
        'aria-controls': 'popover-version-selector'
      }
    ];
  }

  return (
    <Panel.LEGACY borderLeft={0} borderTop={0} borderRight={0}>
      <Panel.LEGACY.Section actions={panelActions}>
        <LabelledValue label="Status">
          <StatusTag status={test.status} />
        </LabelledValue>
        <LabelledValue label="Test ID" value={id} />
        {!!subaccountId && (
          <LabelledValue label="Subaccount">
            <Subaccount id={subaccountId} name={subaccountName} shrinkLength={12} />
          </LabelledValue>
        )}
      </Panel.LEGACY.Section>
    </Panel.LEGACY>
  );
};

StatusPanel.displayName = 'StatusPanel';

const mapStateToProps = (state, props) => ({
  latest: selectLatestVersionNumberFromParams(state, props),
  ...selectIdAndVersionFromParams(state, props)
});
export default withRouter(connect(mapStateToProps, {})(StatusPanel));
